import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import BaseResponseDTO from '../models/validation/BaseResponseDTO';
import SchoolDTO from '../models/school/SchoolDTO';
import KeyValueDTO from '../models/generic/KeyValueDTO';
import KeyValueListDTO from '../models/generic/KeyValueListDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import SchoolFullSyncDTO from '../models/school/SchoolFullSyncDTO';
import AddSchoolDTO from '../models/school/AddSchoolDTO';
import UpdateSchoolDTO from '../models/school/UpdateSchoolDTO';
import PostedIntArray from '../models/generic/PostedIntArray';
import TableRequestDTO from '../models/datatable/TableRequestDTO';

export class SchoolApiController {
    // post: School/AddSchool
    public RouteAddSchool = () => `School/AddSchool`;
    public addSchool(addSchoolDTO: AddSchoolDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteAddSchool();
        return HttpApi.RestRequest<any, BaseResponseDTO>(addSchoolDTO, 'post', url, requestOptions);
    }
    // post: School/UpdateSchool
    public RouteUpdateSchool = () => `School/UpdateSchool`;
    public updateSchool(updateSchoolDTO: UpdateSchoolDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteUpdateSchool();
        return HttpApi.RestRequest<any, BaseResponseDTO>(updateSchoolDTO, 'post', url, requestOptions);
    }
    // get: School/GetSchool/${schoolId}
    public RouteGetSchool = (schoolId: number) => `School/GetSchool/${schoolId}`;
    public getSchool(schoolId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<SchoolDTO>> {
        let url = this.RouteGetSchool(schoolId);
        return HttpApi.RestRequest<any, SchoolDTO>(null, 'get', url, requestOptions);
    }
    // get: School/GetAllSchools
    public RouteGetAllSchools = () => `School/GetAllSchools`;
    public getAllSchools(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllSchools();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: School/GetSchoolsForCurrentUser
    public RouteGetSchoolsForCurrentUser = () => `School/GetSchoolsForCurrentUser`;
    public getSchoolsForCurrentUser(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetSchoolsForCurrentUser();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: School/GetAllSchoolsByClientId/${clientId}
    public RouteGetAllSchoolsByClientId = (clientId: number) => `School/GetAllSchoolsByClientId/${clientId}`;
    public getAllSchoolsByClientId(clientId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllSchoolsByClientId(clientId);
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: School/GetAllSchools/${districtId}
    public RouteGetAllSchoolsByDistrict = (districtId: number) => `School/GetAllSchools/${districtId}`;
    public getAllSchoolsByDistrict(districtId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllSchoolsByDistrict(districtId);
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // post: School/GetSchoolsByDistricts
    public RouteGetSchoolsByDistricts = () => `School/GetSchoolsByDistricts`;
    public getSchoolsByDistricts(districtIds: PostedIntArray, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetSchoolsByDistricts();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(districtIds, 'post', url, requestOptions);
    }
    // post: School/GetAllSchoolsForSchoolClientType
    public RouteGetAllSchoolsForSchoolClientType = () => `School/GetAllSchoolsForSchoolClientType`;
    public getAllSchoolsForSchoolClientType(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetAllSchoolsForSchoolClientType();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'post', url, requestOptions);
    }
    // get: School/GetAllSchoolsForDistrict
    public RouteGetAllSchoolsForDistrict = () => `School/GetAllSchoolsForDistrict`;
    public getAllSchoolsForDistrict(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueListDTO>> {
        let url = this.RouteGetAllSchoolsForDistrict();
        return HttpApi.RestRequest<any, KeyValueListDTO>(null, 'get', url, requestOptions);
    }
    // post: School/GetSchoolTableData
    public RouteGetSchoolTableData = () => `School/GetSchoolTableData`;
    public getSchoolTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<SchoolDTO>>> {
        let url = this.RouteGetSchoolTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<SchoolDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // get: School/GetSchoolFullSyncByFullSync?fullSyncId=${fullSyncId}
    public RouteGetFullSyncsByDistrictId = (fullSyncId: number) => `School/GetSchoolFullSyncByFullSync?fullSyncId=${fullSyncId}`;
    public getFullSyncsByDistrictId(fullSyncId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<SchoolFullSyncDTO[]>> {
        let url = this.RouteGetFullSyncsByDistrictId(fullSyncId);
        return HttpApi.RestRequest<any, SchoolFullSyncDTO[]>(null, 'get', url, requestOptions);
    }
    // post: School/GetSchoolFullSyncTableData?districtFullSyncId=${districtFullSyncId}
    public RouteGetSchoolFullSyncTableData = (districtFullSyncId: number) => `School/GetSchoolFullSyncTableData?districtFullSyncId=${districtFullSyncId}`;
    public getSchoolFullSyncTableData(tableRequest: TableRequestDTO, districtFullSyncId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<SchoolFullSyncDTO>>> {
        let url = this.RouteGetSchoolFullSyncTableData(districtFullSyncId);
        return HttpApi.RestRequest<any, TableResponseDTO<SchoolFullSyncDTO>>(tableRequest, 'post', url, requestOptions);
    }
}
var service = new SchoolApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/SchoolApiController.ts